import {
  PRESUPUESTADOR_CLEAR_ITEM_NUEVO,
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_BEGIN,
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_FAILURE,
} from './constants'

export function clearItemNuevo() {
  return {
    type: PRESUPUESTADOR_CLEAR_ITEM_NUEVO,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_BEGIN:
    case PRESUPUESTADOR_CLEAR_ITEM_NUEVO:
    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_FAILURE:
      if (action.type === PRESUPUESTADOR_CLEAR_ITEM_NUEVO) {
        state.resale_price_increase = 0
      }
      return {
        ...state,
        specialBonification: null,
        costoPatentamientoValidation: {},
        nuevo: null,
        selectedStock: null,
        lineasFinancieras: [],
        getLineasFinancierasError: null,
        cuotasAfinanciar: null,
        montoAfinanciar: null,
        selectedLineaFinanciera: null,
        presupuestoGuardado: {
          ...state.presupuestoGuardado,
          special_discount: 0
        },
        special_discount: 0,
        // TODO: limp miar cotizaciones
        entregaUsados: state.entregaUsados.map((usado) => {
          const origCotizacion = state.cotizaciones.find((cotizado) => cotizado.matricula === usado.patente);
          if (origCotizacion) {
            return { ...usado, final_take_price: origCotizacion.quote.prices[0].amount }
          } else if (state.presupuestoGuardado) { //Controlo si es un presupuesto ya guardado
            let precioAux = usado.final_take_price || 0
            if(state.presupuestoGuardado.Taking_cars){
              if(state.presupuestoGuardado.Taking_cars.length > 0){
                state.presupuestoGuardado.Taking_cars.forEach(car=>{
                  if(usado.patente === car.patente){
                    precioAux = car.final_take_price
                  }
                })
              }
            }
            return { ...usado, final_take_price: precioAux }
          } else if (Number(usado.peritado) === 6) { //Controlo si es peritado
            return { ...usado, final_take_price: usado.original_price }
          } else {
            // Solo por si falla el servicio de cotizador
            return { ...usado, final_take_price: 0 }
          }
        }),
      }

    default:
      return state
  }
}
